/**
 * Masks string
 * @param value String to mask
 * @param mask Mask to apply to that string
 * @returns Masked string
 */
export const mask = function (value: string | null | undefined, stringMask = '*') {
  if (value == null) return undefined;
  if (typeof value !== 'string') return undefined;
  if (value.trim() === '') return undefined;

  return value.replace(/\w(?=.{4})/g, stringMask);
};
